import React, { createContext, useContext, useState } from 'react';

const CRTContext = createContext();

export function CRTProvider({ children }) {
  const [crtEnabled, setCrtEnabled] = useState(false);

  function toggleCRT() {
    setCrtEnabled(prev => !prev);
  }

  return (
    <CRTContext.Provider value={{ crtEnabled, toggleCRT }}>
      {children}
    </CRTContext.Provider>
  );
}

export function useCRT() {
  return useContext(CRTContext);
}
